export interface NavLink {
  label: string;
  to: string;
  /** Match only the exact path for active state (needed for the Home "/" link). */
  end?: boolean;
}

/** Primary navigation, mapped to SRS page structure (§6). */
export const NAV_LINKS: NavLink[] = [
  { label: 'Home', to: '/', end: true },
  { label: 'About', to: '/about' },
  { label: 'Programs', to: '/programs' },
  { label: 'Events', to: '/events' },
  { label: 'Resources', to: '/resources' },
  { label: 'News', to: '/news' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' },
];
